import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * @param slug sinister's slug
 * @param payload sinister's info
 *
 * Update sinisters or sinister
 * @return {Object} sinister update list info
 */

export default ({ slug }) =>
  Vue.$http.post(`sinister/detail/${slug}/`)
    .then(res => res.data)
